import { WIDGETS, WIDGET_TYPES } from '/widgets';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { useEffect, useState } from 'react';
import { Result } from 'srs-middleware';
import { EndpointRequest, EndpointQuery } from "interfaces";
import { EmptyResultError, returnEmptyResultError } from 'widgets/endpointDecorators';

/**
 * Hook to fetch data from the given endpoint
 *
 * @param result
 * @param selectedDefinitionName
 * @param type
 * @param endpointQuery
 * @returns {{data: null, loading: boolean, error: null}}
 */
export const useFetchEndpointData = returnEmptyResultError(
	(
		result: Result,
		selectedDefinitionName: string,
		type: WIDGET_TYPES,
		endpointQuery: EndpointQuery //TODO create a type for this.
	)=>{
	// fires when the filteredResult changes or the endpoint query changes
	const { data, loading, error } = useAsyncCallback(async () => {
		if (!result?.resultId || !endpointQuery?.options) return; // data: null, loading: false, error: null

		// retrieve the correct endpoint based on the type
		const endpoint: EndpointRequest = WIDGETS[type].endpoint;

		// use filtered Result (which may not be filtered) to retrieve the data for the given endpoint
		return await endpoint(
			result,
			selectedDefinitionName,
			endpointQuery.options
		);
	}, [endpointQuery, selectedDefinitionName, result, type]);

	// Trigger a react error if the network request fails
	const [, setTriggerError] = useState(null);
	useEffect(() => {
		if (error) {
			setTriggerError(() => {
				throw error;
			});
		}
	}, [error]);

	return { data, loading, error };
})
